import { createSelector } from 'reselect';

import { selectCurrentUser } from '@lib/selectors';
import selectSettings from '@lib/selectors/selectSettings';

const selectSubAccountSettings = createSelector(
  selectCurrentUser,
  selectSettings,
  // WORKAROUND sub-accounts are using master user settings by default,
  // so this selector lets us use the proper sub-account settings stored on `user.userSetting`
  // https://app.clickup.com/t/7gehc5
  // @ts-ignore
  (currentUser, settings) => currentUser && settings[currentUser.userSetting || currentUser.setting],
);

export default selectSubAccountSettings;
